import { Box, Stack } from "@mui/material";
import { Field } from "formik";
import { TextField } from "formik-mui";

export default function NachtragFieldsContent() {
  return (
    <Stack direction="column">
      <Box
        display={"grid"}
        sx={{ gridTemplateColumns: ["1fr", "1fr 1fr 1fr"], gap: 2 }}
      >
        <Field component={TextField} label="Bemerkung *" name="bemerkung" />
        <Field component={TextField} label="Summe *" name="summe" />
        <Field
          component={TextField}
          label={"Datum *"}
          name="datum"
          type={"date"}
          InputLabelProps={{ shrink: true }}
        />
      </Box>
    </Stack>
  );
}
